// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  IAM_publicKey: "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAy5B16SjDuKFCNEuuEeA9jCBbUvcV1+ASu4w1v1XnyofO5PZCwT6ij2+zSqnQhXCZPyQa374EMG+t1BR9k19zWEkP+IFxv1GaFDBvRCvCme4KSr624AUmAMjoRPnS6xOx2AnrJkt2ODsIm9ECcfCKMw0JvyXp3CpO7MH0+rEgbz2/67wHoIjqMW+0thFtM1pSMOD/ZD5rvF+CFuru/YFtR8jgCItMChW6oF8Ex2s/lbao0YJWItFOPB9sasOSKVYWYPQ4tVc3mREpA0VTzaBYYZV9MWH5d//maDUVSQ0BxOql0n5Ay3j88PNQZfjsDtgmGdBF8FtG84JPbh17r7iq6QIDAQAB-----END PUBLIC KEY-----",
// "apiURL_Core": "http://localhost:41312/api/",

// {
    
//   "apiURL_Core": "https://cognix.uat.aurizon.com.au:8003/api/",
//   "apiURL_Authentication": "https://cognix.uat.aurizon.com.au:8003/LDAP/api/",
//   "Authentication_Type": "LDAP",
//   "Mandatory_To_Encrypt_PD": "NO"
// }
//"apiURL_Core": "https://cognix.uat.aurizon.com.au:8003/api/",//aurizon
  //apiURL_Core: 'http://localhost:41312/api/', //Local
  //apiURL_Core: string = 'http://10.220.8.142:8012/api/', //CellC UAT
  //apiURL_Core: string = 'https://apcognixcellc.za.cellc.net:8008/api/', //CellC PROD
  //apiURL_Core: string = 'http://10.251.231.21:8198/api/', //WebInspept
  //apiURL_Core: string = 'https://10.251.230.145:8043/api/', //SIT

  //apiURL_Core: string = 'http://cognix.uat.aurizon.com.au:8003/api/', //Aurizon
  //apiURL_Core: string = 'http://inctpzetstap01.globe.tcs.com:8198/api/', //Local
  //apiURL_Core: string = 'https://xbsap-workflowuat.corp.xerox.com:8004/api/', //Xerox

  //apiURL_Core: string = 'https://ec2amaz-qsru91h.np.iaasapps.morconnect.com:8003/api/', //MORRISON-SIT

  //apiURL_Authentication: string = 'http://10.220.8.142:8011/api/',//CellC UAT
  //apiURL_Authentication: string = 'https://apcognixcellc.za.cellc.net:8009/api/',// CellC PROD
  //apiURL_Authentication: ''



};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
